/** Turns a raw enum name like `em_annual_fee_type` into a readable `Em Annual Fee Type`. */
export const humanizeEnumName = (enumName: string): string =>
	enumName
		.replace(/[_-]+/g, ' ')
		.replace(/([a-z\d])([A-Z])/g, '$1 $2')
		.trim()
		.split(' ')
		.filter(Boolean)
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(' ');

/** Case-insensitive `includes`, used by both the name list and the value filters. */
export const matchesSearch = (value: string, search: string): boolean =>
	value.toLowerCase().includes(search.trim().toLowerCase());
